
import { QueovalBase, QueovalDate } from '../global';
import { Select } from '../utilities';
import { ActionCoAction, ActionCoActionCo, ActionCoContact, ActionCoDevis, ActionCoProject } from './action-co-devis.model';
import { Corporation } from './action-co.model';


export class ActionCoLDMModel extends QueovalBase {
  Contexte: ActionCoLDMContexte;
  LDM: ActionCoLDM;
  ListMission: Array<ActionCoMission>;
  constructor() {
    super();
    this.LDM = new ActionCoLDM();
    this.ListMission = new Array<ActionCoMission>();
    this.Contexte = new ActionCoLDMContexte();
  }
}


export class ActionCoLDMContexte {
  IdClient: string;
  Client: Corporation;
  ListTypeDoc: Array<Select>;
  ListDossierPermanent: Array<Select>;
  ListContactPrincipal: Array<ActionCoContact>;
  ActionCo: ActionCoActionCo;
  constructor() {
    this.ListTypeDoc = new Array<Select>();
    this.ListDossierPermanent = new Array<Select>();
    this.ListContactPrincipal = new Array<ActionCoContact>();
    this.ActionCo = new ActionCoActionCo();
  }

}


export class ActionCoLDM {
  Ident: string;
  Titre: string;
  Info: string;
  Commentaire: string;
  FileExist: boolean;

  Dossier: string;
  TypeDoc: Select;

  MontantAvantRemise: number;
  Remise: number;
  Montant: number;

  NumeroDoc: string;
  DateDoc: string;

  EtatInt: string;
  DevisSigne: boolean;
  ReadOnly: boolean;
  DevisPerdu: boolean;
  DateSignature: QueovalDate;
  DatePerdu: QueovalDate;
  constructor() {
    this.TypeDoc = new Select();
  }
}

export class ActionCoMission {
  Ident: string;
  Type: string;
  Info: string;
  Millesime: string;
  Montant: number;
  Relation: string;
  BoName: string;
}
